import { computed, inject, Injectable, signal } from '@angular/core';

import { UserRole, UserService } from '@app/services/user/user.service';

import type { AuthLogoutOptions } from './auth-logout.service';

@Injectable({ providedIn: 'root' })
export class LogoutFeedbackFlowService {
  readonly isFeedbackRequested = computed(
    () => this.userService.userRoleGate() === UserRole.User && this.pendingLogoutOptions() !== null,
  );

  private readonly userService = inject(UserService);
  private readonly pendingLogoutOptions = signal<AuthLogoutOptions | null>(null);

  requestLogoutFeedback(options?: AuthLogoutOptions): boolean {
    if (this.userService.userRoleGate() !== UserRole.User) {
      return false;
    }

    if (this.pendingLogoutOptions() === null) {
      this.pendingLogoutOptions.set(options ?? {});
    }

    return true;
  }

  completePendingLogout(): AuthLogoutOptions | undefined {
    const options = this.pendingLogoutOptions() ?? undefined;
    this.pendingLogoutOptions.set(null);
    return options;
  }

  clearPendingLogout(): void {
    this.pendingLogoutOptions.set(null);
  }
}
